var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"f-text"},[_vm._v(" CHANGE IS IN THE AIR® ")]),_c('div',{staticClass:"f-text"},[_vm._v(" SmartAC.com ")]),_c('div',{staticClass:"f-text"},[_vm._v(" Copyright "+_vm._s(_vm.year)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }